import { KeyValuePair } from '../util/key-value-pair';

export class PrimeTreeTableModel {
    data : TreeTableDataModel;
    expanded : boolean;
    children : PrimeTreeTableModel[] ;
  
    constructor() {
      this.data = new TreeTableDataModel();
      this.children = [];
    }
  }
  
  export class TreeTableDataModel {
    id : string;
    attachmentCount : number;
    parentId : string;
    fieldValues : KeyValuePair[];
  
    constructor() {
      this.fieldValues = [];
    }
  }